import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  font-size: 18px;

  > input[type='checkbox']:checked + label:before {
    background: ${ (props) => props.theme.colors.grau2 };
  }

  > input[type='checkbox']:hover + label:before,
  > input[type='checkbox']:checked + label:after {
    cursor: pointer;
  }

  > input[type='checkbox']:checked + label:after {
    position: absolute;
    top: 10px;
    left: 5px;
    transform: translateY(-50%);
    color: ${ (props) => props.theme.colors.weiss };
    display: inline-block;
    font: normal normal normal 14px 'aok-icons-functional';
    font-size: 10px;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: '';
  }

  & + & {
    margin-top: 15px;
  }

  .label {
    padding-left: 30px;
    cursor: pointer;
    line-height: 1.39;
    letter-spacing: normal;
    font-size: 18px;

    :before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      background: ${ (props) => props.theme.colors.weiss };
      border: 1px solid ${ (props) => props.theme.colors.grau2 };
      border-radius: 5px;
    }

    & > * {
      margin-left: 8px;
    }
  }
`
